// src/components/programs/JobOrders/PreviewJobVoucherModal.jsx
import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, CircularProgress, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Close, Print } from "@mui/icons-material";
import ReactDOMServer from "react-dom/server";
import useGetJobVoucher from "../../../hooks/jobVouchers/useGetJobVoucher";
import useExportJobVoucherPdf from "../../../hooks/jobVouchers/useExportJobVoucherPdf";
import PrintJobVoucher from "./PrintJobVoucher";
import { useGetSettings } from "../../../hooks/Settings/useGetSettings";

const PreviewJobVoucherModal = ({ open, onClose, jobVoucherId, program, onPrintSuccess }) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";

    const { jobVoucher, isLoading } = useGetJobVoucher(jobVoucherId, { enabled: open && !!jobVoucherId });
    const { exportJobVoucherPdfMutate, isPending: isExporting } = useExportJobVoucherPdf();
    const { Settings } = useGetSettings();
    const logoUrl = Settings?.data?.logo?.url || '';

    const handlePrint = () => {
        if (!jobVoucher) return;

        const htmlContent = ReactDOMServer.renderToString(
            <PrintJobVoucher program={program} jobVoucher={jobVoucher} lng={lng} logoUrl={logoUrl} />
        );

        exportJobVoucherPdfMutate(
            {
                jobVoucherId: jobVoucher.id,
                html: htmlContent,
                filename: `${jobVoucher.voucher_number || 'voucher'}.pdf`,
            },
            {
                onSuccess: () => {
                    if (onPrintSuccess) onPrintSuccess();
                }
            }
        );
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {lng === 'ar' ? "معاينة الفاوتشر" : "Preview Voucher"}
                <IconButton onClick={onClose} size="small">
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ backgroundColor: "#f5f5f5" }}>
                {isLoading || !jobVoucher ? (
                    <Box display="flex" justifyContent="center" p={4}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Box sx={{
                        width: '210mm',
                        minHeight: '297mm',
                        margin: '0 auto',
                        backgroundColor: '#fff',
                        boxShadow: 3,
                        transform: 'scale(0.8)',
                        transformOrigin: 'top center',
                        border: '1px solid #ccc',
                    }}>
                        <PrintJobVoucher program={program} jobVoucher={jobVoucher} lng={lng} logoUrl={logoUrl} />
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={isExporting}>
                    {lng === 'ar' ? "إلغاء" : "Cancel"}
                </Button>
                <Button
                    onClick={handlePrint}
                    variant="contained"
                    color="success"
                    startIcon={isExporting ? <CircularProgress size={20} /> : <Print />}
                    disabled={isExporting || isLoading || !jobVoucher}
                >
                    {lng === 'ar' ? "تصدير PDF" : "Export PDF"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PreviewJobVoucherModal;

